module.exports = __webpack_public_path__ + "static/media/admin-cripto.ff97e169.png";